export default __webpack_public_path__ + "static/media/logo-text-w.552818c6.png";